var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSol = function SvgSol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#sol_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBFFFD",
    d: "M5.95 12.634a.38.38 0 0 1 .277-.122h9.577c.174 0 .262.224.138.355l-1.892 2.011a.38.38 0 0 1-.277.122H4.196c-.174 0-.262-.224-.138-.355z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.95 5.122A.38.38 0 0 1 6.227 5h9.577c.174 0 .262.224.138.355L14.05 7.366a.38.38 0 0 1-.277.122H4.196c-.174 0-.262-.224-.138-.355zM14.05 8.854a.38.38 0 0 0-.277-.122H4.196c-.174 0-.262.224-.138.356l1.892 2.01a.38.38 0 0 0 .277.122h9.577c.174 0 .262-.224.138-.355z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_svg__a",
    x1: 20,
    x2: 0,
    y1: 2.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};
export default SvgSol;